var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groupListItem",style:(_vm.backgroundImage),on:{"click":_vm.select}},[_c('div',{staticClass:"groupName"},[_vm._v(_vm._s(_vm.group.groupDescription))])])
}
var staticRenderFns = []

export { render, staticRenderFns }